import { AxiosRequestConfig } from 'axios';

import { RequirementShowItem } from '@shared/apis/requirementsApi.types';
import { getQueriesAsSearch } from '@shared/utils/common';
import { $httpRootApi } from '@shared/utils/http-client';

import {
  AcquisitionsBoardLanePayload,
  AcquisitionsBoardPayload,
  AcquisitionsBoardResponse,
  AcquisitionShowPayload,
  AcquisitionsIndexPayload,
  AcquisitionsIndexResponse,
  AcquisitionValidatePublishToSocietyPayload,
  AcquisitionValidatePublishToSocietyResponse,
  RequirementAvailabilityIndexPayload,
  RequirementAvailabilityIndexResponse,
  RequirementAvailabilityShowItem,
  RequirementAvailabilityShowPayload,
} from './acquisitionsApi.types';

export const acquisitionsQueries = {
  index: async (payload: AcquisitionsIndexPayload, config?: AxiosRequestConfig) =>
    await $httpRootApi.get<AcquisitionsIndexResponse>(`/acquisitions${getQueriesAsSearch(payload.query)}`, config),

  board: async (payload: AcquisitionsBoardPayload, config?: AxiosRequestConfig) =>
    await $httpRootApi.get<AcquisitionsBoardResponse>(
      `/acquisitions/board${getQueriesAsSearch(payload.query)}`,
      config
    ),

  boardLane: async (payload: AcquisitionsBoardLanePayload, config?: AxiosRequestConfig) =>
    await $httpRootApi.get<AcquisitionsIndexResponse>(
      `/acquisitions/board/${payload.laneKey}${getQueriesAsSearch(payload.query)}`,
      config
    ),

  show: async (payload: AcquisitionShowPayload, config?: AxiosRequestConfig) =>
    await $httpRootApi.get<RequirementShowItem>(`/acquisitions/${payload.id}`, config),

  availabilityIndex: async (payload: RequirementAvailabilityIndexPayload, config?: AxiosRequestConfig) =>
    await $httpRootApi.get<RequirementAvailabilityIndexResponse>(
      `/acquisitions/${payload.acquisitionId}/availability-schedule${getQueriesAsSearch(payload.query)}`,
      config
    ),

  availabilityShow: async (payload: RequirementAvailabilityShowPayload, config?: AxiosRequestConfig) =>
    await $httpRootApi.get<RequirementAvailabilityShowItem>(
      `/acquisitions/availability-schedule/${payload.scheduleMatchId}`,
      config
    ),

  validatePublishToSociety: async (payload: AcquisitionValidatePublishToSocietyPayload, config?: AxiosRequestConfig) =>
    await $httpRootApi.get<AcquisitionValidatePublishToSocietyResponse>(
      `/acquisitions/${payload.id}/validate_publish_to_society`,
      config
    ),
};
